import { render, staticRenderFns } from "./sales-order-filter.vue?vue&type=template&id=f2a2c6e2&scoped=true&"
import script from "./sales-order-filter.vue?vue&type=script&lang=js&"
export * from "./sales-order-filter.vue?vue&type=script&lang=js&"
import style0 from "./sales-order-filter.vue?vue&type=style&index=0&id=f2a2c6e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2c6e2",
  null
  
)

export default component.exports